import { useEffect, useState } from 'react';
import DoctorUserIcon from '../../../assets/svgs/DoctorUserIcon';
import { HorarioProps } from '../../../interfaces/props/SaudeOnline/HorarioProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './styles.css'
import { TypeScheduleTabsEnum } from '../../../interfaces/enum/TypeScheduleTabsEnum';
import Hours from './Hours';
import { Horarios } from '../../../interfaces/entities/Horarios';
import { Button, useMediaQuery } from '@mui/material';
import { sxBoxChevron, sxButton, sxLabelCalendar } from './sxProps';
import { aceitaTermoResponsabilidade, getHorariosDisponiveisPeriodo } from '../../../services/SaudeOnlineService';
import LoadingApp from '../../../components/LoadingApp';
import HourErrorModal from './HourErrorModal';
import TermoDeUsoModal from './TermoDeUsoModal';
import dayjs from 'dayjs';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import TypographyAccessibility from '../../../components/Accessibility/TypographyAccessibility';
import WhiteContainer from '../../../components/Accessibility/WhiteContainer';
import Calendar from '../../../components/Calendar/Calendar';


function Horario(props: HorarioProps) {
    const isMobile = useMediaQuery("(max-width: 1400px)");
    const [day, setDay] = useState<string>('');
    const [month, setMonth] = useState<string>('');
    const [year, setYear] = useState<string>('');
    const [selectedDate, setSelectedDate] = useState<Date | null>(props.selectedDate);
    const [hoursList, setHoursList] = useState<Horarios[]>([]);
    const [selectedHour, setSelectedHour] = useState<Horarios | null>(props.selectedHour);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [eraseHour, setEraseHour] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [openTermsOfUse, setOpenTermsOfUse] = useState<boolean>(false);

    const accessibility = useAccessibility();

    useEffect(() => {
        if (props.doctor.dtDispon !== null) {
            const availability = props.doctor.dtDispon.split('/');

            setDay(availability[0])
            setMonth(setMesNaData(availability[1]))
            setYear(availability[2])
        }
    }, []);

    useEffect(() => {
        if (props.selectedHour !== null && !eraseHour) {
            setEraseHour(true)
            setSelectedHour(props.selectedHour)
        }
        else {
            setSelectedHour(null);
        }
    }, [selectedDate]);

    const setMesNaData = (monthNum: string) => {

        switch (monthNum) {
            case '01':
                return 'Janeiro';
            case '02':
                return 'Fevereiro';
            case '03':
                return 'Março';
            case '04':
                return 'Abril';
            case '05':
                return 'Maio';
            case '06':
                return 'Junho';
            case '07':
                return 'Julho';
            case '08':
                return 'Agosto';
            case '09':
                return 'Setembro';
            case '10':
                return 'Outubro';
            case '11':
                return 'Novembro';
            case '12':
                return 'Dezembro';
            default:
                return 'Mês inválido';
        }
    }

    const goBack = () => {
        props.backStep(TypeScheduleTabsEnum.GuiaMedico, false);
    }

    const changeDoc = () => {
        props.backStep(TypeScheduleTabsEnum.GuiaMedico, true);
    }

    const handleDate = (date: Date) => {
        setSelectedDate(date)
    }

    const handleMonth = async (date: Date) => {
        const start = dayjs(date).startOf('month');
        const end = dayjs(date).endOf('month').add(1, 'day');
        setShowLoading(true);
        const result = await getHorariosDisponiveisPeriodo(
            props.doctor.idPessoa, 
            props.doctor.idInstal, 
            start.toDate(), 
            end.toDate(), 
            props.typeOfAppointment.charAt(0));
        if (result !== null) {
            setHoursList(result);
        }
        setShowLoading(false)
    }

    useEffect(() => {
        const today = dayjs().month(new Date().getMonth()).startOf('month');
        handleMonth(today.toDate());
    }, [])

    const handleHour = (hour: Horarios) => {
        setSelectedHour(hour);
    }

    const handleSchedule = () => {
        if (selectedDate !== null && selectedHour !== null) {
            switch (props.teleTerm?.indAceite) {
                case 'N':
                    setOpenTermsOfUse(true);
                    break;
                case 'S':
                    props.handleSchedule(selectedDate, selectedHour);
                    break;
                default:
                    break;
            }

        }
        else {
            setOpen(true)
        }
    }

    const handleCloseModal = () => {
        setOpen(false)
    }

    const handleTermsOfUse = async (idTermoResponsabilidade: string) => {
        if (selectedDate !== null && selectedHour !== null) {
            await aceitaTermoResponsabilidade(idTermoResponsabilidade, 'S').then(() => {
                setOpenTermsOfUse(false);
                props.handleSchedule(selectedDate, selectedHour);
            })
        }
    }

    const closeTermsOfUse = () => {
        setOpenTermsOfUse(false);
    }

    return (
        <div className='page-container'>
            <div className='content-doctor'>
                <h1 className="hour-title" style={accessibility.textStyleAccessibility}>Encontre horários disponíveis</h1>
                <div className='doctos-card-holder' style={accessibility.contrastStyle} tabIndex={0}>
                    <div className="doctors-card-icon">
                        <DoctorUserIcon />
                    </div>
                    <div className="doctors-card-info">
                        <h1 className='selected-doctor-title' style={accessibility.textStyleAccessibility} >Médico(a) selecionado(a):</h1>
                        <h1 className='doctors-name' style={accessibility.textStyleAccessibility}>{props.doctor.nomePessoa}</h1>
                        <span className='doctors-info' style={accessibility.textStyleAccessibility}><b>Especialidade:</b> {props.doctor.descrEspec}</span>
                        <span className='doctors-info' style={accessibility.textStyleAccessibility}><b>Endereço:</b> {props.doctor.logradouro} {props.doctor.numero} - {props.doctor.bairro}, {props.doctor.cidade} - {props.doctor.uf} / CEP: {props.doctor.cep}</span>
                        <span className='doctors-info' style={accessibility.textStyleAccessibility}><b>Telefone:</b> {props.doctor.telefone}</span>
                        <span className='doctors-info' style={accessibility.textStyleAccessibility}><b>Provável disponibilidade:</b>{props.doctor.dtDispon === null ? '' : `${day} de ${month} de ${year}`}</span>
                        <div>
                            <button 
                                className="back-schedule-button" 
                                onClick={changeDoc} 
                                style={accessibility.textStyleAccessibility} 
                                tabIndex={0}
                                aria-label={`trocar médico ${props.doctor.nomePessoa}`}
                            >
                                <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Trocar médico(a)</u>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div>
                    <TypographyAccessibility sx={sxLabelCalendar} >
                        Selecione uma data no calendário
                    </TypographyAccessibility>
                    <Calendar handleDate={handleDate} handleMonth={handleMonth} selectedDate={selectedDate} daysList={hoursList.map(day => day.data)} isLoading={showLoading}/>
                </div>
                {
                    selectedDate !== null &&
                    <>
                        {!isMobile &&
                            <div className="content-chevron">
                                <WhiteContainer shadow sx={sxBoxChevron}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </WhiteContainer>
                            </div>
                        }
                        <div className="content-hours">
                            <Hours selectedDate={selectedDate} doctor={props.doctor} handleHour={handleHour} selectedHour={selectedHour} hoursList={hoursList} />
                        </div>

                    </>
                }
            </div>
            <div className='content-button'>
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleSchedule}
                    sx={sxButton}
                    style={accessibility.buttonStyleAccessibility}
                    fullWidth>
                    <span style={accessibility.buttonTextStyleAccessibility}>PROSSEGUIR</span>
                </Button>
            </div>
            <button className="back-button" onClick={goBack} aria-label="voltar para guia médico">
                <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u style={accessibility.textStyleAccessibility}>Voltar</u>
            </button>
            <HourErrorModal open={open} handleCloseModal={handleCloseModal} />
            <TermoDeUsoModal handleTermsOfUse={handleTermsOfUse} closeTermsOfUse={closeTermsOfUse} open={openTermsOfUse} />

            <LoadingApp showLoading={showLoading} />
        </div>
    )
}

export default Horario;